angular
  .module('landingPage', [
    'giCarousel',
    'giAdp',
    'giRails',
    'giRemoting',
    'giTooltip',
    'giTracking',
    'giTranslation',
    'giLocationEncoder',
    'giExperiences',
    'giModal',
    'templates',
    'giIcons',
    'giMultiBannerBuilder',
    'giCustomerNotifications',
    'ngAnimate',
    'ng-rails-csrf',
    'giForms',
    'gixModal',
    'giTracking',
    'exceptionOverwrite',
  ])
  .run(($rootScope, t) => ($rootScope.t = t));
